import React from 'react';
import { Container } from '@components/Container';
import { Section } from '@components/Section';
import { MultiAppointmentForm } from '@pages/Appointment/pages/MultiAppointment/MultiAppointmentForm';

export const CreateAppointment = () => (
  <div className="main-content">
    <Container size="lg">
      <div className="panel">
        <Section containerSize="md">
          <MultiAppointmentForm />
        </Section>
      </div>
    </Container>
  </div>
);
